import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData, TextInput } from '../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HeaderIntroTextForProtocolConverter extends CmsConverterService<HeaderIntroTextForProtocolData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      textHighlighted: formData.st_text_highlighted ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      link: formData.st_link ?? defaultLinkData,
      fileSize: Math.round((formData.st_link.fileSize / 1000000) * 10) / 10,
      hasFileAttached: !!formData.st_link?.url ?? false,
      fileType: formData.st_link?.mime ?? ''
    }
  }
}

export const HEADER_INTRO_TEXT_FOR_PROTOCOL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HeaderIntroTextForProtocolData>>('HeaderIntroTextForProtocolConverterToken')

export interface HeaderIntroTextForProtocolData extends ConvertedComponentData {
  headline: TextInput;
  textHighlighted: TextInput;
  text: TextInput;
  link: LinkData;
  fileSize: number;
  fileType: string;
  hasFileAttached: boolean;
}
